module.exports = __webpack_public_path__ + "img/DE05716.f45e7c29.png";